import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MobileFirstComponent } from './modules/mobile-first/mobile-first.component';
import { ProjectTypeComponent } from './modules/project-core/project-type/project-type.component';
import { ApplicationGuard } from './modules/usermgmt/guards/application.guard';

const routes: Routes = [
  {
    path: 'projectType',
    component: ProjectTypeComponent,
    canActivate: [ApplicationGuard]
  },
  {
    path: 'home/mobile',
    component: MobileFirstComponent,
    loadChildren: () => import("./modules/mobile-first/mobile-first.module").then((module: any)=> module.MobileFirstModule),
    canActivate: [ApplicationGuard]

  },
  {
    path: 'home/web',
    loadChildren: () => import("ngx-web-app").then((m: any)=> m.NgxWebAppModule),
    canActivate: [ApplicationGuard]
  },
  {
    path: 'home',
    loadChildren: () => import("./modules/project-core/project-core.module").then((m: any)=> m.ProjectCoreModule),
    canActivate: [ApplicationGuard]
  },
  {
    path: 'um',
    loadChildren: () => import('usermgmt').then(m => m.UsermgmtModule)
  },
  
  {
    path: '',
    redirectTo:'splash',
    pathMatch:'full'
  },
  {
    path: 'splash',
    loadChildren: () => import('./modules/splash/splash.module').then(m => m.SplashModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./modules/disable-user/disable-user.module').then(m => m.DisableUserModule)
  },{
    path: 'privacy-policy',
    loadChildren: () => import('./modules/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
  },
  {
    path: '',
    loadChildren: () => import('./modules/usermgmt/usermgmt.module').then(m => m.UsermgmtModule)
  },
  
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
